import { createContext } from 'react'

const SpecificRisksContext = createContext()

export default SpecificRisksContext
